import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { EmptyStateComponent } from '../../@commons/ui-components/empty-state/empty-state.component';
import RoutesConstants from '../../@commons/constants/routes.constants';

/**
 * État vide des onglets de l'agenda (A2) : Willy, une phrase, et deux portes
 * vers ce qui donne du travail au jardin (le calendrier, les notifications).
 * Une liste vide sans un mot laissait croire à une panne. Porté par l'état
 * vide partagé `vw-empty-state`.
 */
@Component({
  selector: 'vw-agenda-empty',
  imports: [EmptyStateComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <vw-empty-state data-test="agenda-empty" willy="veggies" [titleKey]="messageKey"
      actionKey="agenda.empty.calendar" secondaryActionKey="agenda.empty.notifications"
      (action)="go(calendar)" (secondaryAction)="go(notifications)"></vw-empty-state>
  `,
})
export class AgendaEmptyComponent {
  private readonly router = inject(Router);

  /** Phrase de l'onglet : rien à faire, ou rien d'archivé. */
  @Input() messageKey = 'agenda.empty.current';

  readonly calendar = RoutesConstants.CALENDAR;
  readonly notifications = RoutesConstants.NOTIFICATIONS;

  go(path: string): void {
    void this.router.navigateByUrl(path);
  }
}
